const styles = theme => ({
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginBottom: 16
  }),
  container: {
    display: "flex",
    height: "100px",
    alignItems: "center",
    justifyContent: "center",
    border: "1px dashed #005795"
  },
  content: {
    color: "#FF7043",
    fontSize: "1rem!important"
  }
});

export default styles;
